<template>
	<div class="push__bottom">
		<fieldset class="fieldset" role="group">
			<legend :class="['fieldset__legend', {'fieldset__legend--xl' : type == 'heading'}]">    
				<h1 v-if="type == 'heading'" v-html="title">{{title}}</h1>
				<h2 v-if="type == 'default'" v-html="title">{{title}}</h2> 
			</legend>		
			<div v-if="detailsTitle" class="push__top">
				<Details :id="detailsId" :title="detailsTitle" :message="detailsMessage"/>
			</div>
			<slot></slot>
		</fieldset>   
	</div>
</template>

<script>
export default {
	name: 'Fieldset',
	props: {
		id: String,
		title: String,
		type: String,
		detailsTitle: String,
		detailsMessage: String
	},
    computed: {
        detailsId() {
            return `${this.id}-details`;
        },
    },
	data() {
		return {
			currentYear : new Date().getFullYear()
		}
	}
}
</script>